import React from "react";
import { Helmet } from "react-helmet-async";
import environment from "environment";
export default function SEO({ title, description }) {
  return (
    <Helmet prioritizeSeoTags>
      {(environment.isProduction || environment.isDevelopment) && (
        <>
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta
            name="keywords"
            content="eservice, probate, judiciary, will, grant, sg courts"
          />
          <meta
            property="og:image"
            content={`${window.location.origin}/logo192.png`}
          />
        </>
      )}
      {environment.isUAT && (
        <>
          <title>{title}</title>
          <meta name="robots" content="noarchive" />
          <meta name="robots" content="noindex" />
        </>
      )}
    </Helmet>
  );
}
